<template>
    <header>
        <div class="row">
            <div class="col-lg-5 col-sm-12 header-left">
                <router-link class="step" to="/" exact>
                    <div class="logo">
                        <img src="../../assets/logo/rft.svg" />
                    </div>
                    <div class="baseline">
                        <span>Open to innovation,</span>
                        <span>closed to fire</span>
                    </div>
                </router-link>
            </div>
            <div class="col-sm-7 header-right">
                <div class="header-right-inner">
                    <ul class="menu" v-click-outside="hideLanguageDropdown">
                        <li>
                            <a href="#" @click.stop="showHideLanguageDropdown">
                                <span class="mdi mdi-earth"></span>
                                {{ $t("language") }}
                            </a>
                            <div class="dropdown"  v-if="languagesVisible">
                                <p>
                                    {{ $t("Choose your language") }}
                                </p>
                                <ul>
                                    <li v-for="language in languages" v-on:click="setLanguageAndHide(language.code)" class="mdi mdi-chevron-right">
                                        {{language.name}}
                                    </li>
                                </ul>
                            </div>
                        </li>
                        <li>
                            <a href="#">
                                <span class="mdi mdi-login"></span>
                                {{ $t("Inloggen") }}
                            </a>
                        </li>
                        <li>
                            <a href="#">
                                {{ $t("Contact") }}
                            </a>
                        </li>
                    </ul>
                    <div class="e-search search">
                        <input type="text" v-bind:placeholder="$t('Zoeken')" />
                        <button type="submit" class="icon">
                            <span class="mdi mdi-magnify"></span>
                        </button>
                    </div>
                </div>
            </div>

            <div class="opener-mobile" v-on:click="showMenu = !showMenu">
                <span class="mdi mdi-menu"></span>
            </div>

            <div v-if="showMenu" class="mobile-menu">
                <div class="closer-mobile" v-on:click="showMenu = !showMenu">
                    <span class="mdi mdi-close"></span>
                </div>

                <div class="mobile-menu-content">
                    <div class="e-search search">
                        <input type="text" placeholder="Zoeken" />
                        <button type="submit" class="icon">
                            <span class="mdi mdi-magnify"></span>
                        </button>
                    </div>

                    <ul class="menu">
                        <li>
                            <a href="#">
                                <span class="mdi mdi-earth"></span>
                                {{ $t("België") }}
                            </a>

                        </li>
                        <li>
                            <a href="#">
                                <span class="mdi mdi-earth"></span>
                                {{ $t("Inloggen") }}
                            </a>

                        </li>
                        <li>
                            <a href="#">
                                {{ $t("Contact") }}
                            </a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
    import translations from "../../lang/translations"
    import apiService from "../../services/request";
    import { processLanguageParameter } from '../../helpers'

    export default {
        name: "Top",
        data () {
            return {
                showMenu: false,
                languagesVisible: false,
                languages: []
            }
        },
        methods: {
          showHideLanguageDropdown() {
            this.languagesVisible = !this.languagesVisible;
          },
          hideLanguageDropdown() {
            if (this.languagesVisible === true) {
              this.languagesVisible = false;
            }
          },
          setLanguageAndHide(locale) {
            processLanguageParameter(this.languages, locale)
            this.hideLanguageDropdown();
          },
          setTranslations(translations) {
            for (let translation in translations) {
              if (translations[translation].language) {
                this.languages.push({
                  'code': translation,
                  'name': translations[translation].language
                })
              }
            }
            processLanguageParameter(this.languages, this.$route.query.lang, translations)
          }
        },
        directives: {
          'click-outside': {
            priority: 700,
            bind (el, binding, vnode) {
              el.clickOutsideEvent = function (event) {
                if (!(el === event.target || el.contains(event.target))) {
                  vnode.context[binding.expression](event);
                }
              };
              document.body.addEventListener('click', el.clickOutsideEvent)
            },
            unbind(el, binding, vnode) {
              document.body.removeEventListener('click', el.clickOutsideEvent)
            }
          },
          stopProp(event) {event.stopPropagation() }
        },
        mounted: function() {
          apiService.getTranslations('nl-be', this.setTranslations)
        }
    }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/general/Top.vue